import { createRouter, createWebHistory } from 'vue-router'
import PrivacyPolicyPage from '@/views/MainPage/PrivacyPolicyPage.vue'
import SupportLandingPage from '@/views/MainPage/SupportLandingPage.vue'

const routes = [
  {
    path: '/',
    name: 'Support',
    component: SupportLandingPage,
    meta: { title: 'Wall Labs' }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicyPage,
    meta: { title: 'Privacy Policy | Wall Labs' }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach((to) => {
  document.title = to.meta?.title || 'Wall Labs'
})

export default router
